// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vueperslide[data-v-7efae13d]{opacity:1;transition:.3s ease-in-out;transform:scale(1);border-color:#ddd;transform-origin:center center}.vueperslides--fixed-height.vueperslides--bullets-outside[data-v-7efae13d]{margin-bottom:10px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
